module.exports = __webpack_public_path__ + "static/media/LQ_Jacquard_Vela_DK Grey_LT Grey.f5534c98.png";